import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Layout from "@/_LayoutsRelated/layout/Layout";
import { unbxdAnalytics } from "@/redux/actions/unbxdActions";
import { serverUrl } from "@globalConfig";
import NewPostView from "@/pages/post/PostViewComponents/NewPostView";
import { extractPostId } from "@/utils/GlobalJavascriptFunction";
import useApi from "@hooks/useApi";
import Loader from "@componentsShared/Loader/Loader";
import { useFullPageData } from "@/common/Contexts/FullPageContext";
import { api__getNewPostViewData } from "@/apis/posts/getNewPostViewData";
import useFullLoading from "@hooks/useFullLoading";
import { usePostDetails } from "@/common/Contexts/PostDetailsContext";
function PostViewNew() {
  var _postDetails, _postDetails2, _postDetails2$details, _postDetails3, _postDetails3$details, _postDetails4, _postDetails4$details, _location$state;
  var location = useLocation();
  var postId = extractPostId(location.pathname);
  var _usePostDetails = usePostDetails(),
    setPostDetails = _usePostDetails.setPostDetails;
  var postViewApiResponseFullPageData = useFullPageData();
  var loading, error, postDetails;
  if (postViewApiResponseFullPageData) {
    postDetails = postViewApiResponseFullPageData.postDetails;
    loading = false;
  } else {
    var _useApi = useApi([postId], function () {
      return api__getNewPostViewData(postId);
    });
    var _useApi2 = _slicedToArray(_useApi, 3);
    loading = _useApi2[0];
    error = _useApi2[1];
    postDetails = _useApi2[2];
  }
  var fullPageLoading = useFullLoading();
  var metaTags = (_postDetails = postDetails) === null || _postDetails === void 0 ? void 0 : _postDetails.meta;
  var switchLink = (_postDetails2 = postDetails) === null || _postDetails2 === void 0 ? void 0 : (_postDetails2$details = _postDetails2.details) === null || _postDetails2$details === void 0 ? void 0 : _postDetails2$details.product_url_alt;
  useEffect(function () {
    var params = {
      action: "product_view",
      url: serverUrl + location.pathname + location.search,
      pid: postId
    };
    unbxdAnalytics(params);
  }, []);
  useEffect(function () {
    document.title = "".concat(metaTags !== null && metaTags !== void 0 && metaTags.title ? metaTags === null || metaTags === void 0 ? void 0 : metaTags.title : "");
  }, [metaTags === null || metaTags === void 0 ? void 0 : metaTags.title]);
  useEffect(function () {
    setPostDetails(postDetails);
    return function () {
      setPostDetails(null);
    };
  }, [(_postDetails3 = postDetails) === null || _postDetails3 === void 0 ? void 0 : (_postDetails3$details = _postDetails3.details) === null || _postDetails3$details === void 0 ? void 0 : _postDetails3$details.id]);
  return /*#__PURE__*/React.createElement(Layout, {
    mobileHasBack: true,
    hideDownloadBanner: true,
    switchLink: switchLink,
    linksForSearch: true,
    mainClass: ["PBT", ((_postDetails4 = postDetails) === null || _postDetails4 === void 0 ? void 0 : (_postDetails4$details = _postDetails4.details) === null || _postDetails4$details === void 0 ? void 0 : _postDetails4$details.limited_quantity) && "limitedAvaPBT"].join(" "),
    disableLoader: true,
    hideOrangeHeadBtn: true
  }, (fullPageLoading || loading) && /*#__PURE__*/React.createElement(Loader, null), !loading && /*#__PURE__*/React.createElement(NewPostView, {
    financeView: true,
    postData: postDetails,
    loading: loading,
    screen_view_referral: location === null || location === void 0 ? void 0 : (_location$state = location.state) === null || _location$state === void 0 ? void 0 : _location$state.screen_view_referral
  }));
}
export default PostViewNew;